// extracted by mini-css-extract-plugin
module.exports = {"root":"EmptyDashboard_root__nB07p","track":"EmptyDashboard_track__MEnQc","intro":"EmptyDashboard_intro__FiAs2","hero":"EmptyDashboard_hero__7ImH3"};